import { addDisplayName, addProps, flowMax } from 'ad-hok'
import React, { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { isFeedItemMedia, UserFeed } from 'shared/src/api/types'
import cx from 'classnames'

import { Footer } from 'components/footer'
import { MediaProductStack } from './MediaProductStack'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    rowGap: 24,
    columnGap: 14,
    marginBottom: 10,
  },
  wantMore: {
    width: '100%',
  },
})

interface Props {
  feed: UserFeed
  onClick: (id: number) => void
  className?: string
}

export const GridFeed: FC<Props> = flowMax(
  addDisplayName('GridFeed'),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ feed: { media }, onClick, classes, className }) => (
    <div className={cx(classes.container, className)}>
      {media.map((item, index) => (
        <React.Fragment key={index}>
          {isFeedItemMedia(item) && (
            <div onClick={() => onClick(item.id)} id={item.id.toString()}>
              <MediaProductStack media={item} />
            </div>
          )}
        </React.Fragment>
      ))}
      <Footer className={classes.wantMore} />
    </div>
  )
)
